import React from "react";
import "./Message.css";
import {
  G4Cliente,
  G4Wait,
  G4Atendente,
} from "../../../pages/conversation/components/styled";

const urlRegex = /(\b(?:https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|]|\bwww\.[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;

const MessageLink = ({ text, time, user, config }) => {
  const parts = text.split(urlRegex).filter(Boolean);

  const content = (
    <>
      {parts.map((part, index) => {
        if (part && part.match(urlRegex)) {
          const href = part.startsWith("www.") ? `http://${part}` : part;
          return (
            <a
              key={index}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: user === "cliente" ? '#fff' : 'inherit', textDecoration: 'underline' }}
            >
              {part}
            </a>
          );
        }
        return (
          <span key={index} style={{ whiteSpace: "pre-wrap" }}>
            {part}
          </span>
        );
      })}
      <div id="date_G4_flex">
        {new Date(time).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })}
      </div>
    </>
  );

  return (
    <>
      {user === "cliente" && <G4Cliente color={config.color}>{content}</G4Cliente>}
      {user === "atendente" && <G4Atendente>{content}</G4Atendente>}
      {user === "wait" && <G4Wait color={config.color}>{content}</G4Wait>}
    </>
  );
};

export default MessageLink;